import toast, { type Toast, type ToastOptions } from 'react-hot-toast';
import { FiAlertTriangle } from 'react-icons/fi';
import { cn } from '../../cn';

const ToastFunction = () => {
  const error = (message: string, opts?: Partial<Toast>) => {
    toast.error(message, opts);
  };
  const success = (message: string, opts?: Partial<Toast>) => {
    toast.success(message, opts);
  };
  const promise = (message: string, opts?: Partial<Toast>) => {
    toast.loading(message, opts);
  };
  const warning = (message: string, opts?: Partial<Toast>) => {
    const options = {
      icon: <FiAlertTriangle />,
      iconTheme: {
        primary: '#faf089',
        secondary: '#faf089',
      },
      style: { backgroundColor: '#f6e05e', color: '#3D3D3D' },
    };
    toast(message, { ...options, ...opts });
  };
  const info = (message: string, opts?: Partial<Toast>) => {
    const options = {
      primary: '#000',
      secondary: '#000',
      style: { backgroundColor: '#63B3ED', color: '#fff' },
    };

    toast(message, { ...options, ...opts });
  };
  const simple = (message: string, opts?: Partial<Toast>) => {
    toast(message, opts);
  };
  const custom = (message: string) => {
    return toast((t: ToastOptions) => (
      <span>
        Custom and <b>bold</b> and <b>{message ?? ''}</b>
        <button
          type='button'
          aria-label='close'
          className='border-black-200 ext-md ml-3 rounded-lg border bg-gray-100 p-1.5 text-gray-700'
          onClick={() => toast.dismiss(t.id)}
        >
          Dismiss
        </button>
      </span>
    ));
  };

  const updateToast = (fn: () => void) => {
    const clearCache = async (t: Toast) => {
      toast.dismiss(t.id);
      fn();

      // try {
      // fn();

      // // Clear all caches
      // if ('caches' in window) {
      //   const cacheNames = await caches.keys();
      //   await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
      // }

      // // Unregister all service workers
      // if ('serviceWorker' in navigator) {
      //   const registrations = await navigator.serviceWorker.getRegistrations();
      //   await Promise.all(registrations.map((r) => r.unregister()));
      // }
      // } catch (err) {
      //   console.error('Error clearing cache or service worker:', err);
      // }

      // // Force reload after cleanup
      // window.location.reload();
    };

    return toast.custom(
      (t: Toast) => (
        <span
          className={cn(
            'max-w-md items-center bg-background p-6 rounded-lg shadow-md',
            'flex space-x-12 w-full justify-between',
            t.visible ? 'animate-enter' : 'animate-leave',
          )}
        >
          <span className='text-content4-foreground text-xl'>A new version is available!</span>
          <button
            type='button'
            aria-label='close'
            className='rounded-lg text-lg px-4 bg-primary-500 p-2 text-primary-900'
            onClick={() => {
              clearCache(t);
            }}
          >
            Update
          </button>
        </span>
      ),
      { duration: Infinity, position: 'bottom-right', id: 'update-toast' },
    );
  };
  return {
    simple,
    success,
    warning,
    error,
    custom,
    info,
    updateToast,
    promise,
    toast,
  };
};
export const toaster = ToastFunction();
